import { render } from "./Create-page.vue?vue&type=template&id=0692ab62&scoped=true"
import script from "./Create-page.vue?vue&type=script&lang=js"
export * from "./Create-page.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=0692ab62&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0692ab62"]])

export default __exports__